import { h, ref, computed, defineComponent } from 'vue'
import { isObject } from '../utils/helpers'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-slot-component />
   */
  name: 'AkSlotComponent',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    component: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    name: {
      type: String,
      default: 'default',
    },
    props: {
      type: Object,
      default: () => ({}),
    },
    tag: {
      type: String,
      default: 'div',
    },
  },

  /**
   * @param {Object} props - The properties of the component
   * @description Sets up the component and returns an object containing
   * all of the attributes for the component to use.
   */

  setup(props) {
    const root = ref(null)

    /**
     * @type {Object}
     * @description A reactive property to return the $slots object of
     * the parent component
     */
    const slots = computed(() => {
      if (isObject(props.component.ctx)) {
        return props.component.ctx.slots || props.component.ctx.$slots
      } else {
        return props.component.slots || props.component.$slots
      }
    })

    /**
     * @type {Object}
     * @description A reactive property to return the slot that is to be
     * rendered into the component
     */
    const slot = computed(() => {
      if (isObject(slots.value)) {
        return slots.value[props.name]
      } else {
        return () => h('div', 'no component to render')
      }
    })

    return () => h(props.tag, { ref: root }, slot.value(props.props))
  },
})
